import React, { useState, useEffect, useMemo } from 'react';
import ReactDOM from 'react-dom';
import { Col, Badge, Button, Accordion, Form, Spinner, Dropdown } from 'react-bootstrap';
import { X, Phone, Calendar, Mail, Bell, FileText, Clock, Target, Shield, Edit2, Check, XCircle, Save, RefreshCw, AlertCircle, Briefcase, ChevronDown, ChevronUp, Globe, Plus, PlusCircle, User } from 'react-feather';
import { Icon } from '@iconify/react/dist/iconify.js';
import { updateUserProfile, getProfessionalSituation, getSubscriptions, deactivateUserSubscription } from '../helper/Api/AdminApi';
import { toast } from 'react-toastify';

const getTodayFormatted = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const getTomorrowFormatted = () => {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  const year = tomorrow.getFullYear();
  const month = String(tomorrow.getMonth() + 1).padStart(2, '0');
  const day = String(tomorrow.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const formatToYMD = (dateStr) => {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return '';
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${yearToFull(y)}-${m}-${day}`;
};

const yearToFull = (y) => String(y).padStart(4, '0');

const calculateEndDate = (startDateStr, durationMonths, extensionMonths) => {
  if (!startDateStr) return '';
  const date = new Date(startDateStr);
  const totalMonths = (parseInt(durationMonths, 10) || 0) + (parseInt(extensionMonths, 10) || 0);
  date.setMonth(date.getMonth() + totalMonths);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const parseBooleanActive = (val) => {
  if (val === false || val === 0 || val === '0' || val === 'false' || val === 'False') return false;
  if (val === true || val === 1 || val === '1' || val === 'true' || val === 'True') return true;
  return true;
};

const extractIsActive = (user) => {
  if (!user) return true;
  const rawIsActive = user.IsActive !== undefined
    ? user.IsActive
    : (user.isActive !== undefined
      ? user.isActive
      : (user._raw?.IsActive !== undefined
        ? user._raw.IsActive
        : (user._raw?.isActive !== undefined ? user._raw.isActive : undefined)));
  return parseBooleanActive(rawIsActive);
};

const INITIAL_NEW_SUBSCRIPTION_STATE = {
  SubscriptionID: '',
  DurationInMonths: '',
  ExtensionInMonths: 0,
  StartDate: getTodayFormatted(),
  SituationProfessionnelle: '',
  HorizonDePlacement: '',
  ObjectifDePlacement: [],
  AversionAuRisque: ''
};

const customStyles = `
.drawer-header-modern {
  padding: 16px 20px !important;
  background-color: #FFFFFF !important;
  border-bottom: 1px solid #F1F5F9 !important;
  box-sizing: border-box !important;
  width: 100% !important;
  flex-shrink: 0 !important;
}
.user-avatar-modern {
  width: 44px !important;
  height: 44px !important;
  min-width: 44px !important;
  max-width: 44px !important;
  border-radius: 50% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-weight: 700 !important;
  font-size: 18px !important;
  background: linear-gradient(135deg, #FDF7EE 0%, #F5E8D3 100%) !important;
  color: #CBA370 !important;
  border: 2px solid #FFFFFF !important;
  box-shadow: 0 2px 6px rgba(203, 163, 112, 0.2) !important;
  flex-shrink: 0 !important;
}
.personal-fields {
  border: 1px solid #F1F5F9 !important;
  background-color: #FFFFFF;
  border-radius: 10px;
  padding: 12px 16px;
  margin-bottom: 8px;
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
}
.personal-fields:hover {
  background-color: #FAFAFA;
  border-color: #E2E8F0 !important;
}
.personal-fields.editing {
  background-color: #FFFDF9;
  border: 1.5px solid #CBA370 !important;
  padding: 12px 16px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(203, 163, 112, 0.15);
}
.personal-fields.error {
  border: 1.5px solid #DC3545 !important;
  background-color: #FFF5F5;
  border-radius: 10px;
  padding: 12px 16px;
}
.field-icon-box {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background-color: #FAF5EE;
  color: #CBA370;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  flex-shrink: 0;
}
.field-label-text {
  font-size: 13.5px;
  font-weight: 500;
  color: #334155;
}
.field-value-text {
  color: #CBA370;
  font-weight: 600;
  font-size: 13.5px;
  text-align: right;
}
.edit-btn-modern {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  background: #F8FAFC;
  border: 1px solid #E2E8F0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #94A3B8;
  transition: all 0.2s;
  cursor: pointer;
  padding: 0;
}
.edit-btn-modern:hover {
  background: #FAF5EE;
  color: #CBA370;
  border-color: #CBA370;
}
.edit-btn-modern.active {
  background: #CBA370;
  color: #FFFFFF;
  border-color: #CBA370;
}
.btn-close-circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #E2E8F0;
  background: #FFFFFF;
  color: #64748B;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  cursor: pointer;
  padding: 0;
}
.btn-close-circle:hover {
  background: #F1F5F9;
  color: #0F172A;
  border-color: #CBD5E1;
}
.drawer-tabs-container {
  display: flex;
  background-color: #FFFFFF;
  border-bottom: 1px solid #E2E8F0;
  padding: 0 16px;
  gap: 12px;
}
.drawer-tab-btn {
  border: none;
  background: transparent;
  font-size: 13.5px;
  font-weight: 500;
  color: #64748B;
  border-bottom: 2.5px solid transparent;
  padding: 12px 18px;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
}
.drawer-tab-btn:hover {
  color: #CBA370;
}
.drawer-tab-btn.active {
  color: #CBA370;
  font-weight: 600;
  border-bottom-color: #CBA370;
}
.land-details-text {
  font-size: 14px;
  font-weight: 500;
  color: black;
}
.land-details-value {
  font-size: 14px;
  font-weight: 600;
  color: #126B3A;
  text-align: center;
}
.subscription-history-item {
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
  background-color: #F9FAFB;
}
.subscription-title {
  color: #CBA370;
  font-weight: 600;
  font-size: 16px;
}
.subscription-detail {
  color: #374151;
  font-size: 14px;
  margin-top: 4px;
}
.subscription-date {
  color: #6B7280;
  font-size: 12px;
}
.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #6B7280;
}
.accordion-button:not(.collapsed) {
  background-color: #F8FDF8 !important;
  color: #CBA370 !important;
  box-shadow: none;
}
.accordion-button:focus {
  border-color: #CBA370;
  box-shadow: 0 0 0 0.25rem rgba(203, 163, 112, 0.25);
}
.question-section {
  border-left: 2px solid #CBA370;
  padding-left: 10px;
  margin-bottom: 14px;
}
.question-title {
  font-size: 13px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 8px;
}
.option-item {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
}
.option-label {
  font-size: 12.5px;
  color: #374151;
  line-height: 1.3;
}
.checked-option {
  color: #CBA370;
  font-weight: 500;
}
.accordion-item {
  border: 1px solid #E5E7EB !important;
  border-radius: 8px !important;
}
.accordion-header button {
  padding: 10px 14px !important;
  font-size: 13px !important;
  font-weight: 500 !important;
}
.accordion-body {
  padding: 12px 14px !important;
}
.accordion-button::after {
  width: 14px;
  height: 14px;
  background-size: 14px;
}
.subscription-box {
  border-radius: 6px;
  background: #FFFFFF;
  margin-top: 24px
}
  .border-bottom-dashed {
  border-bottom: 1px solid #F1F5F9;
}
  

.compact-accordion .accordion-header button {
  padding: 1px 10px !important;
  min-height: 30px;
  display: flex;
  align-items: center;
}

.accordion-title-text {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: #111827;
  line-height: 1;
}

.header-date-range {
  font-size: 12px !important;
  font-weight: 400;
  line-height: 1;
}

.accordion-edit-btn {
  color: #CBA370 !important;
  padding: 2px 6px !important;
  text-decoration: none !important;
  font-size: 12px !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 4px !important;
  line-height: 1 !important;
}

.accordion-edit-btn:hover {
  background-color: #FFF7ED !important;
  border-radius: 4px;
}

.accordion-deactivate-btn {
  color: #DC2626 !important;
  padding: 2px 6px !important;
  text-decoration: none !important;
  font-size: 12px !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 4px !important;
  line-height: 1 !important;
}

.accordion-deactivate-btn:hover {
  background-color: #FEF2F2 !important;
  border-radius: 4px;
}

/* Compact status badge sizing */
.status-badge {
  font-size: 10.5px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 50px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  height: 20px;
}

.status-badge.active {
  background-color: #E6F4EA;
  color: #137333;
}

.status-badge.inactive {
  background-color: #FCE8E6;
  color: #C5221F;
}

.custom-arrow-parent {
  width: 18px;
  border-radius: 4px;
  background: #FFF7ED;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #D4A373;
  font-size: 16px;
  line-height: 1;
  padding-bottom: 2px;
  transition: transform 0.2s ease;
}
.custom-arrow {
  height: 100%;
  width:: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.question-row {
  border-top: 1px solid #F1F5F9;
  padding: 12px 0px;
}
.accordion-button::after {
  display: none !important;
}
.accordion-button.collapsed .custom-arrow {
  transform: rotate(180deg);
}
.question-title {
  font-size: 13px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 8px;
}
.option-label {
  font-size: 12.5px;
  color: #6B7280;
}
.checked-option {
  color: #D4A373;
  font-weight: 500;
}
.custom-radio {
  appearance: none;
  -webkit-appearance: none;
  width: 14px;
  height: 14px;
  border: 1.5px solid #9CA3AF;
  border-radius: 50%;
  position: relative;
  cursor: default;
}
.custom-radio:checked {
  border-color: #D4A373;
}
.custom-radio:checked::after {
  content: '';
  position: absolute;
  width: 6px;
  height: 6px;
  background: #D4A373;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.user-avatar {
  width: 60px !important;
  height: 60px !important;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 20px;
  background-color: #CBA37033;
  color: #CBA370;                         
}
.edit-actions {
  display: flex;
  gap: 8px;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #E5E7EB;
}
.edit-btn {
  background: none;
  border: none;
  color: #CBA370;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s;
  font-size: 12px;
}
.edit-btn:hover {
  background-color: #FFF7ED;
}
.edit-input {
  border: 1px solid #E5E7EB;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 14px;
  width: 100%;
  max-width: 250px;
  transition: border-color 0.2s;
}
.edit-input:focus {
  border-color: #CBA370;
  outline: none;
  box-shadow: 0 0 0 3px rgba(203, 163, 112, 0.1);
}
.edit-input:disabled {
  background-color: #F9FAFB;
  cursor: not-allowed;
}
.edit-input.error {
  border-color: #DC3545;
}
.edit-input.error:focus {
  border-color: #DC3545;
  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);
}
.password-toggle-btn {
  background: none;
  border: none;
  color: #6B7280;
  font-size: 12px;
  padding: 4px 8px;
  cursor: pointer;
}
.password-toggle-btn:hover {
  color: #CBA370;
}
.validation-error {
  color: #DC3545;
  font-size: 11px;
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
}
/* Subscription Edit Styles */
.subscription-edit-section {
  background-color: #FFFAF0;
  border: 1px solid #CBA370;
  border-radius: 8px;
  padding: 16px;
  margin-top: 12px;
}
.subscription-edit-label {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 6px;
}
.subscription-edit-value {
  font-size: 14px;
  font-weight: 500;
  color: #CBA370;
}
.subscription-select {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #E5E7EB;
  border-radius: 6px;
  font-size: 14px;
  background-color: white;
  color: #374151;
  transition: all 0.2s;
}
.subscription-select:focus {
  border-color: #CBA370;
  outline: none;
  box-shadow: 0 0 0 3px rgba(203, 163, 112, 0.1);
}
.subscription-edit-actions {
  display: flex;
  gap: 8px;
  margin-top: 12px;
  justify-content: flex-end;
}

/* CRITICAL FIX: Drawer overlay styles - COMPLETELY PREVENTS INTERACTION WITH MAIN PAGE */
body.drawer-open {
  overflow: hidden !important;
}

.drawer-backdrop {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  background-color: rgba(0, 0, 0, 0.4) !important;
  z-index: 1049 !important;
  animation: fadeIn 0.3s ease;
  pointer-events: auto !important; /* This BLOCKS all clicks */
  cursor: default !important;
}

/* Prevent any click events from passing through */
.drawer-backdrop * {
  pointer-events: none !important;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

.user-drawer {
  position: fixed !important;
  right: 0 !important;
  top: 0 !important;
  bottom: 0 !important;
  height: 100vh !important;
  width: 572px !important;
  max-width: 100vw !important;
  background-color: #FFFFFF !important;
  box-shadow: -5px 0 25px rgba(0,0,0,0.15) !important;
  z-index: 1050 !important;
  overflow-y: hidden !important;
  overflow-x: hidden !important;
  box-sizing: border-box !important;
  pointer-events: auto !important;
  transform: translateX(0);
  animation: slideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  display: flex !important;
  flex-direction: column !important;
}

/* Ensure drawer content is clickable and adheres to box-sizing */
.user-drawer * {
  box-sizing: border-box !important;
  pointer-events: auto !important;
}
`;

const DetailItem = ({ label, value, icon, isEditing, onEdit, field, fieldType, onFieldChange, showPassword = false, onTogglePassword, error, onBlur }) => {
  const [localValue, setLocalValue] = useState(value || '');

  useEffect(() => {
    setLocalValue(value || '');
  }, [value]);

  const handleChange = (e) => {
    const newValue = e.target.value;
    setLocalValue(newValue);
    if (onFieldChange) {
      onFieldChange(field, newValue);
    }
  };

  const getInputType = () => {
    if (field === 'password') {
      return showPassword ? 'text' : 'password';
    }
    if (field === 'dob') {
      return 'date';
    }
    if (field === 'contactNumber') {
      return 'tel';
    }
    if (field === 'email') {
      return 'email';
    }
    return 'text';
  };

  const displayValue = () => {
    if (field === 'password' && !isEditing) {
      return '••••••••';
    }
    return value || 'N/A';
  };

  return (
    <div className={`personal-fields ${isEditing ? 'editing' : ''} ${error ? 'error' : ''}`} data-field={field}>
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center">
          <span className="field-icon-box">{icon}</span>
          <span className="field-label-text">{label}</span>
        </div>
        <div className="d-flex align-items-center gap-2">
          {isEditing ? (
            <div className="d-flex align-items-center gap-2">
              {field === 'password' ? (
                <div className="d-flex flex-column align-items-end">
                  <div className="d-flex align-items-center gap-2">
                    <input
                      type={getInputType()}
                      value={localValue}
                      onChange={handleChange}
                      onBlur={onBlur}
                      placeholder="Enter new password"
                      className={`edit-input ${error ? 'error' : ''}`}
                      style={{ maxWidth: '200px' }}
                    />
                    <button
                      className="password-toggle-btn"
                      onClick={onTogglePassword}
                      type="button"
                    >
                      {showPassword ? 'Hide' : 'Show'}
                    </button>
                  </div>
                  {error && (
                    <div className="validation-error">
                      <AlertCircle size={12} />
                      {error}
                    </div>
                  )}
                </div>
              ) : (
                <div className="d-flex flex-column align-items-end">
                  <input
                    type={getInputType()}
                    value={localValue}
                    onChange={handleChange}
                    onBlur={onBlur}
                    max={field === 'dob' ? getTodayFormatted() : undefined}
                    className={`edit-input ${error ? 'error' : ''}`}
                    style={{ maxWidth: field === 'dob' ? '160px' : '220px' }}
                  />
                  {error && (
                    <div className="validation-error">
                      <AlertCircle size={12} />
                      {error}
                    </div>
                  )}
                </div>
              )}
            </div>
          ) : (
            <div className="d-flex flex-column align-items-end">
              <span className="field-value-text" style={{ cursor: field === 'password' ? 'default' : 'pointer' }}>
                {displayValue()}
              </span>
              {error && (
                <div className="validation-error">
                  <AlertCircle size={12} />
                  {error}
                </div>
              )}
            </div>
          )}
          <button
            className={`edit-btn-modern ${isEditing ? 'active' : ''}`}
            onClick={() => onEdit(field)}
            title={isEditing ? 'Confirm' : 'Edit'}
            type="button"
          >
            {isEditing ? <Check size={14} /> : <Edit2 size={14} />}
          </button>
        </div>
      </div>
    </div>
  );
};

const FormQuestion = ({ question, options, selectedValue, icon, isEditing, onOptionChange, field, error, required = false }) => (
  <div className="question-row">
    <div className="question-title d-flex align-items-center gap-2">
      {icon}
      <span>{question} {required && isEditing && <span className="text-danger">*</span>}</span>
    </div>
    <div>
      {options.map((option, index) => (
        <div key={index} className="option-item">
          {isEditing ? (
            <input
              type="radio"
              checked={option === selectedValue}
              onChange={() => onOptionChange(field, option)}
              className="custom-radio"
              style={{ cursor: 'pointer' }}
            />
          ) : (
            <input
              type="radio"
              checked={option === selectedValue}
              readOnly
              className="custom-radio"
            />
          )}
          <span className={`option-label ${option === selectedValue ? 'checked-option' : ''}`}>
            {option}
          </span>
        </div>
      ))}
    </div>
    {error && (
      <div className="validation-error mt-1">
        <AlertCircle size={12} />
        {error}
      </div>
    )}
  </div>
);

const MultiSelectQuestion = ({ question, options, selectedValues, icon, isEditing, onOptionChange, field, error, required = false }) => (
  <div className="question-row">
    <div className="question-title d-flex align-items-center gap-2">
      {icon}
      <span>{question} {required && isEditing && <span className="text-danger">*</span>}</span>
    </div>
    <div>
      {options.map((option, index) => (
        <div key={index} className="option-item">
          {isEditing ? (
            <input
              type="checkbox"
              checked={selectedValues.includes(option)}
              onChange={(e) => {
                const newValues = e.target.checked
                  ? [...selectedValues, option]
                  : selectedValues.filter(v => v !== option);
                onOptionChange(field, newValues);
              }}
              className="custom-radio"
              style={{ cursor: 'pointer' }}
            />
          ) : (
            <input
              type="checkbox"
              checked={selectedValues.includes(option)}
              readOnly
              className="custom-radio"
            />
          )}
          <span className={`option-label ${selectedValues.includes(option) ? 'checked-option' : ''}`}>
            {option}
          </span>
        </div>
      ))}
    </div>
    {error && (
      <div className="validation-error mt-1">
        <AlertCircle size={12} />
        {error}
      </div>
    )}
  </div>
);

const SingleValueQuestion = ({ question, value, icon }) => (
  <div className="question-row">
    <div className="question-title d-flex align-items-center gap-2">
      {icon}
      <span>{question}</span>
    </div>
    <div className="option-item">
      <input
        type="checkbox"
        checked={true}
        readOnly
        className="custom-radio"
      />
      <span className="option-label checked-option">
        {value || 'N/A'}
      </span>
    </div>
  </div>
);

const FilterUserDrawer = ({ selectedUser, onClose, onUpdateUser, onUpdateSuccess }) => {
  const [activeTab, setActiveTab] = useState('personal');
  const [editingFields, setEditingFields] = useState({});
  const [editedData, setEditedData] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const [errors, setErrors] = useState({});
  const [professionalSituations, setProfessionalSituations] = useState([]);
  const [isEditingSubscription, setIsEditingSubscription] = useState(false);
  const [editedSubscription, setEditedSubscription] = useState(null);
  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);
  const [isLoadingSituations, setIsLoadingSituations] = useState(false);
  const [subscriptionErrors, setSubscriptionErrors] = useState({});
  const [deactivatingId, setDeactivatingId] = useState(null);

  // Scenario B: Add New Subscription State
  const [isAddingNewSubscription, setIsAddingNewSubscription] = useState(false);
  const [newSubscriptionData, setNewSubscriptionData] = useState(INITIAL_NEW_SUBSCRIPTION_STATE);
  const [newSubscriptionErrors, setNewSubscriptionErrors] = useState({});
  const [subscriptionList, setSubscriptionList] = useState([]);
  const [loadingSubscriptions, setLoadingSubscriptions] = useState(false);

  // CRITICAL FIX: Prevent body scroll and ALL interactions when drawer is open
  useEffect(() => {
    // Store original body styles
    const originalOverflow = document.body.style.overflow;

    // Prevent body scroll safely
    document.body.style.overflow = 'hidden';
    document.body.classList.add('drawer-open');

    // CRITICAL: Add event listener to prevent all clicks on main content
    const preventClicks = (e) => {
      // Check if click target is inside the drawer
      const drawer = document.querySelector('.user-drawer');
      if (drawer && !drawer.contains(e.target)) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      return true;
    };

    document.addEventListener('click', preventClicks, true);
    document.addEventListener('mousedown', preventClicks, true);
    document.addEventListener('mouseup', preventClicks, true);

    return () => {
      // Restore body styles
      document.body.style.overflow = originalOverflow;
      document.body.classList.remove('drawer-open');

      // Remove event listeners
      document.removeEventListener('click', preventClicks, true);
      document.removeEventListener('mousedown', preventClicks, true);
      document.removeEventListener('mouseup', preventClicks, true);
    };
  }, []);

  // Validation functions
  const validateEmail = (email) => {
    if (!email) return 'Email is required';
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(email)) {
      return 'Please enter a valid email address (e.g., user@domain.com)';
    }
    return '';
  };

  const validatePassword = (password) => {
    if (!password) return ''; // Password is optional
    if (password.length < 8) {
      return 'Password must be at least 8 characters long';
    }
    if (!/[A-Z]/.test(password)) {
      return 'Password must contain at least one uppercase letter';
    }
    if (!/[a-z]/.test(password)) {
      return 'Password must contain at least one lowercase letter';
    }
    if (!/[0-9]/.test(password)) {
      return 'Password must contain at least one number';
    }
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
      return 'Password must contain at least one special character (!@#$%^&*(),.?":{}|<>)';
    }
    return '';
  };

  const validateDOB = (dob) => {
    if (!dob) return ''; // Optional
    const dobDate = new Date(dob);
    const today = new Date();
    today.setHours(23, 59, 59, 999);
    if (isNaN(dobDate.getTime())) {
      return 'Please enter a valid date';
    }
    if (dobDate > today) {
      return 'Date of birth cannot be in the future';
    }
    return '';
  };

  const validateField = (field, value) => {
    let error = '';
    if (field === 'email') {
      error = validateEmail(value);
    } else if (field === 'password' && value) {
      error = validatePassword(value);
    } else if (field === 'contactNumber') {
      if (!value || !value.trim()) {
        error = 'Mobile number is required';
      } else {
        const digits = value.replace(/\D/g, '');
        if (digits.length > 15) {
          error = 'Mobile number cannot exceed 15 digits';
        }
      }
    } else if (field === 'dob') {
      error = validateDOB(value);
    }
    return error;
  };

  const handleValidateField = (field, value) => {
    const error = validateField(field, value);
    setErrors(prev => ({ ...prev, [field]: error }));
    return error;
  };

  // Fetch professional situations
  useEffect(() => {
    const fetchProfessionalSituations = async () => {
      try {
        setIsLoadingSituations(true);
        const response = await getProfessionalSituation();
        if (response && response.Data) {
          // Filter only active situations
          const activeSituations = response.Data.filter(item => item.IsActive === '1' || item.IsActive === 1 || item.IsActive === true);
          setProfessionalSituations(activeSituations);
        }
      } catch (error) {
        console.error('Error fetching professional situations:', error);
      } finally {
        setIsLoadingSituations(false);
      }
    };
    fetchProfessionalSituations();
  }, []);

  // Fetch subscriptions for Scenario B (Add New Subscription)
  useEffect(() => {
    const fetchSubscriptions = async () => {
      try {
        setLoadingSubscriptions(true);
        const response = await getSubscriptions();
        let data = [];
        if (Array.isArray(response)) {
          data = response;
        } else if (response?.Data && Array.isArray(response.Data)) {
          data = response.Data;
        } else if (response?.data && Array.isArray(response.data)) {
          data = response.data;
        }
        setSubscriptionList(data || []);
      } catch (err) {
        console.error('Error fetching subscriptions:', err);
      } finally {
        setLoadingSubscriptions(false);
      }
    };
    fetchSubscriptions();
  }, []);

  // Filter subscription plans where IsActive = 1 and IsDefault = 0
  const eligibleSubscriptionPlans = useMemo(() => {
    return subscriptionList.filter((sub) => {
      const isActive = sub.IsActive === true || sub.IsActive === 1 || sub.IsActive === '1';
      const isDefault = sub.IsDefault === true || sub.IsDefault === 1 || sub.IsDefault === '1';
      return isActive && !isDefault;
    });
  }, [subscriptionList]);

  // Calculated End Date for New Subscription
  const newCalculatedEndDate = useMemo(() => {
    return calculateEndDate(
      newSubscriptionData.StartDate,
      newSubscriptionData.DurationInMonths,
      newSubscriptionData.ExtensionInMonths
    );
  }, [newSubscriptionData.StartDate, newSubscriptionData.DurationInMonths, newSubscriptionData.ExtensionInMonths]);

  // Helper to determine if an invoice/subscription is active
  const isInvoiceActive = (invoice) => {
    if (!invoice?.EndDate) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const endDate = new Date(invoice.EndDate);
    const isStatusActive = invoice.Status === 1 || invoice.Status === '1' || invoice.Status === true || invoice.Status === undefined;
    return isStatusActive && endDate >= today;
  };

  // Check if user currently has an active subscription based on their subscription history
  const userHasActiveSubscription = useMemo(() => {
    if (!selectedUser?.InvoiceHistory || selectedUser.InvoiceHistory.length === 0) {
      return false;
    }
    return selectedUser.InvoiceHistory.some(inv => isInvoiceActive(inv));
  }, [selectedUser]);

  // Initialize edited data when user changes
  useEffect(() => {
    if (selectedUser) {
      const userIsActive = extractIsActive(selectedUser);
      const initialData = {
        contactNumber: selectedUser.contactNumber || '',
        email: selectedUser.email || '',
        dob: selectedUser.dob || '',
        emailAlert: selectedUser.emailAlert || false,
        pushAlert: selectedUser.pushAlert || false,
        password: '',
        firstName: selectedUser.firstName || '',
        lastName: selectedUser.lastName || '',
        os: selectedUser.os || '',
        isActive: userIsActive,
        IsActive: userIsActive,
        userID: selectedUser.userID || selectedUser.id || ''
      };
      setEditedData(initialData);
      setErrors({});
      setHasChanges(false);
      setIsAddingNewSubscription(false);
      setIsEditingSubscription(false);
      setSelectedInvoiceId(null);
    }
  }, [selectedUser]);

  if (!selectedUser) return null;

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    } catch (e) {
      return dateString;
    }
  };

  const getYesNo = (value) => {
    if (value === 1 || value === true) return 'Yes';
    if (value === 0 || value === false) return 'No';
    return 'N/A';
  };

  const handleEditToggle = (field) => {
    if (editingFields[field]) {
      const value = editedData[field] || '';
      const error = handleValidateField(field, value);
      if (!error) {
        setEditingFields(prev => ({ ...prev, [field]: false }));
        setHasChanges(true);
      }
    } else {
      setEditingFields(prev => ({ ...prev, [field]: true }));
      if (field === 'password') {
        setEditedData(prev => ({ ...prev, password: '' }));
        setShowPassword(false);
        setErrors(prev => ({ ...prev, password: '' }));
      }
    }
  };

  const handleFieldChange = (field, value) => {
    setEditedData(prev => ({ ...prev, [field]: value }));
    setHasChanges(true);
    if (field === 'contactNumber' || field === 'dob') {
      const err = validateField(field, value);
      setErrors(prev => ({ ...prev, [field]: err }));
    } else if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  const handleFieldBlur = (field, value) => {
    if (field === 'email' || field === 'password' || field === 'contactNumber' || field === 'dob') {
      handleValidateField(field, value);
    }
  };

  const handleTogglePassword = () => {
    setShowPassword(prev => !prev);
  };

  const handleUndoChanges = () => {
    const userIsActive = extractIsActive(selectedUser);
    const initialData = {
      contactNumber: selectedUser.contactNumber || '',
      email: selectedUser.email || '',
      dob: selectedUser.dob || '',
      emailAlert: selectedUser.emailAlert || false,
      pushAlert: selectedUser.pushAlert || false,
      password: '',
      firstName: selectedUser.firstName || '',
      lastName: selectedUser.lastName || '',
      os: selectedUser.os || '',
      isActive: userIsActive,
      IsActive: userIsActive,
      userID: selectedUser.userID || selectedUser.id || ''
    };
    setEditedData(initialData);
    setEditingFields({});
    setHasChanges(false);
    setShowPassword(false);
    setErrors({});
  };

  const validateAllFields = () => {
    const newErrors = {};
    let hasError = false;

    if (editedData.email !== selectedUser.email) {
      const emailError = validateEmail(editedData.email);
      if (emailError) {
        newErrors.email = emailError;
        hasError = true;
      }
    }

    if (editedData.contactNumber) {
      const phoneError = validateField('contactNumber', editedData.contactNumber);
      if (phoneError) {
        newErrors.contactNumber = phoneError;
        hasError = true;
      }
    }

    if (editedData.dob) {
      const dobError = validateDOB(editedData.dob);
      if (dobError) {
        newErrors.dob = dobError;
        hasError = true;
      }
    }

    if (editedData.password && editedData.password.length > 0) {
      const passwordError = validatePassword(editedData.password);
      if (passwordError) {
        newErrors.password = passwordError;
        hasError = true;
      }
    }

    setErrors(newErrors);
    return !hasError;
  };

  // Scenario C: Save Profile Changes (Profile Only)
  const handleSaveChanges = async () => {
    try {
      const isAllValid = validateAllFields();
      if (!isAllValid) {
        toast.error('Please fix the validation errors before saving.');
        setEditingFields(prev => ({
          ...prev,
          ...(errors.contactNumber ? { contactNumber: true } : {}),
          ...(errors.dob ? { dob: true } : {}),
          ...(errors.email ? { email: true } : {}),
          ...(errors.password ? { password: true } : {})
        }));
        const firstErrorField = Object.keys(errors)[0];
        if (firstErrorField) {
          const element = document.querySelector(`[data-field="${firstErrorField}"]`);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
        return;
      }

      setIsSaving(true);

      const isSavingActive = Boolean(editedData.isActive);
      const updateData = {
        UserID: editedData.userID || selectedUser.userID || selectedUser.id,
        FirstName: editedData.firstName || selectedUser.firstName || '',
        LastName: editedData.lastName || selectedUser.lastName || '',
        EmailID: editedData.email || selectedUser.email,
        ContactNumber: editedData.contactNumber || selectedUser.contactNumber,
        DOB: editedData.dob || selectedUser.dob || '',
        OS: editedData.os || selectedUser.os || '',
        IsActive: isSavingActive,
        EmailAlert: editedData.emailAlert,
        PushAlert: editedData.pushAlert
      };

      if (editedData.password && editedData.password.trim()) {
        updateData.Password = editedData.password.trim();
      }

      const result = await updateUserProfile(updateData);
      toast.success(result.message || 'Profile updated successfully');

      setEditingFields({});
      setHasChanges(false);
      setShowPassword(false);
      setErrors({});

      const updatedUserFromResponse = result.user || result;
      const mergedUpdatedUser = {
        ...selectedUser,
        email: updateData.EmailID,
        dob: updateData.DOB,
        contactNumber: updateData.ContactNumber,
        firstName: updateData.FirstName,
        lastName: updateData.LastName,
        os: updateData.OS,
        isActive: isSavingActive,
        IsActive: isSavingActive,
        emailAlert: updateData.EmailAlert,
        pushAlert: updateData.PushAlert,
        ...(updatedUserFromResponse && typeof updatedUserFromResponse === 'object' ? updatedUserFromResponse : {})
      };
      mergedUpdatedUser.isActive = isSavingActive;
      mergedUpdatedUser.IsActive = isSavingActive;

      if (onUpdateUser) {
        onUpdateUser(mergedUpdatedUser);
      }
      if (onUpdateSuccess) {
        onUpdateSuccess();
      }

      setEditedData({
        contactNumber: mergedUpdatedUser.contactNumber || '',
        email: mergedUpdatedUser.email || '',
        dob: mergedUpdatedUser.dob || '',
        emailAlert: mergedUpdatedUser.emailAlert || false,
        pushAlert: mergedUpdatedUser.pushAlert || false,
        password: '',
        firstName: mergedUpdatedUser.firstName || '',
        lastName: mergedUpdatedUser.lastName || '',
        os: mergedUpdatedUser.os || '',
        isActive: isSavingActive,
        IsActive: isSavingActive,
        userID: mergedUpdatedUser.userID || mergedUpdatedUser.id || ''
      });
    } catch (error) {
      console.error('Error updating profile:', error);
      toast.error(error.response?.data?.Message || error.Message || 'Failed to update profile');
    } finally {
      setIsSaving(false);
    }
  };

  // Scenario A: Subscription Edit Handlers (Active Subscription: Questions & Future EndDate)
  const handleEditSubscription = (invoice) => {
    if (!isInvoiceActive(invoice)) {
      toast.info('Inactive subscriptions cannot be edited. Please add a new subscription.');
      return;
    }

    const usersSubscriptionID = invoice.UsersSubscriptionID || invoice.ID;
    setSelectedInvoiceId(invoice.ID);
    setEditedSubscription({
      UsersSubscriptionID: usersSubscriptionID,
      InvoiceID: invoice.ID,
      EndDate: formatToYMD(invoice.EndDate),
      SubscriptionDetail: {
        SituationProfessionnelle: invoice.SubscriptionDetail?.SituationProfessionnelle || '',
        HorizonDePlacement: invoice.SubscriptionDetail?.HorizonDePlacement || '',
        ObjectifDePlacement: Array.isArray(invoice.SubscriptionDetail?.ObjectifDePlacement)
          ? invoice.SubscriptionDetail.ObjectifDePlacement
          : invoice.SubscriptionDetail?.ObjectifDePlacement
            ? [invoice.SubscriptionDetail.ObjectifDePlacement]
            : [],
        AversionAuRisque: invoice.SubscriptionDetail?.AversionAuRisque || ''
      }
    });
    setSubscriptionErrors({});
    setIsEditingSubscription(true);
  };

  const handleCancelSubscriptionEdit = () => {
    setIsEditingSubscription(false);
    setEditedSubscription(null);
    setSelectedInvoiceId(null);
    setSubscriptionErrors({});
  };

  const handleSubscriptionFieldChange = (field, value) => {
    setEditedSubscription(prev => ({
      ...prev,
      SubscriptionDetail: {
        ...prev.SubscriptionDetail,
        [field]: value
      }
    }));
    if (subscriptionErrors[field]) {
      setSubscriptionErrors(prev => ({ ...prev, [field]: '' }));
    }
  };
  const validateSubscriptionQuestions = (data) => {
    const errors = {};

    if (!data.SituationProfessionnelle?.trim()) {
      errors.SituationProfessionnelle = 'Please select your professional situation';
    }

    if (!data.HorizonDePlacement?.trim()) {
      errors.HorizonDePlacement = 'Please select your investment horizon';
    }

    const objectives = Array.isArray(data.ObjectifDePlacement)
      ? data.ObjectifDePlacement
      : data.ObjectifDePlacement
        ? [data.ObjectifDePlacement]
        : [];

    if (objectives.length === 0) {
      errors.ObjectifDePlacement = 'Please select at least one investment objective';
    }

    if (!data.AversionAuRisque?.trim()) {
      errors.AversionAuRisque = 'Please select your risk tolerance';
    }

    return errors;
  };
  const handleSaveSubscriptionChanges = async () => {
    if (!editedSubscription?.EndDate) {
      setSubscriptionErrors({ EndDate: 'End Date is required' });
      toast.error('End Date is required');
      return;
    }

    const today = getTodayFormatted();

    if (editedSubscription.EndDate < today) {
      setSubscriptionErrors({
        EndDate: 'End Date cannot be earlier than today'
      });
      toast.error('End Date cannot be earlier than today');
      return;
    }

    const questionErrors = validateSubscriptionQuestions(
      editedSubscription.SubscriptionDetail || {}
    );

    if (Object.keys(questionErrors).length > 0) {
      setSubscriptionErrors(questionErrors);
      toast.error('Please answer all subscription questions before saving.');
      return;
    }

    try {
      setIsSaving(true);

      const updateData = {
        UserID: selectedUser.userID || selectedUser.id || editedData.userID,
        EndDate: editedSubscription.EndDate,
        SituationProfessionnelle: editedSubscription.SubscriptionDetail?.SituationProfessionnelle || '',
        HorizonDePlacement: editedSubscription.SubscriptionDetail?.HorizonDePlacement || '',
        ObjectifDePlacement: Array.isArray(editedSubscription.SubscriptionDetail?.ObjectifDePlacement)
          ? editedSubscription.SubscriptionDetail.ObjectifDePlacement
          : [],
        AversionAuRisque: editedSubscription.SubscriptionDetail?.AversionAuRisque || ''
      };

      const result = await updateUserProfile(updateData);
      toast.success(result.message || 'Subscription updated successfully');

      if (onUpdateUser) {
        const updatedUser = { ...selectedUser };
        if (updatedUser.InvoiceHistory) {
          const invoiceIndex = updatedUser.InvoiceHistory.findIndex(
            inv => inv.ID === editedSubscription.InvoiceID
          );
          if (invoiceIndex !== -1) {
            updatedUser.InvoiceHistory[invoiceIndex] = {
              ...updatedUser.InvoiceHistory[invoiceIndex],
              EndDate: editedSubscription.EndDate,
              SubscriptionDetail: { ...editedSubscription.SubscriptionDetail }
            };
          }
        }
        updatedUser.subscriptionEndingDate = editedSubscription.EndDate;
        onUpdateUser(updatedUser);
      }
      if (onUpdateSuccess) {
        onUpdateSuccess();
      }

      setIsEditingSubscription(false);
      setEditedSubscription(null);
      setSelectedInvoiceId(null);
      setSubscriptionErrors({});
    } catch (error) {
      console.error('Error updating subscription:', error);
      toast.error(error.response?.data?.Message || error.Message || 'Failed to update subscription');
    } finally {
      setIsSaving(false);
    }
  };

  const handleDeactivateSubscription = async (invoice) => {
    const userSubscriptionID = invoice.UsersSubscriptionID || invoice.UserSubscriptionID || invoice.ID;
    if (!userSubscriptionID) {
      toast.error('Subscription ID not found');
      return;
    }

    const confirmDeactivate = window.confirm(
      'Are you sure you want to deactivate this active subscription? Once deactivated, a new subscription plan can be assigned.'
    );
    if (!confirmDeactivate) return;

    try {
      setDeactivatingId(invoice.ID);
      const res = await deactivateUserSubscription(userSubscriptionID);
      toast.success(res?.Message || res?.message || 'User subscription deactivated successfully');

      // Update local selectedUser state so the UI immediately reflects the deactivated state
      const todayYMD = getTodayFormatted();
      if (onUpdateUser) {
        const updatedUser = { ...selectedUser };
        if (updatedUser.InvoiceHistory) {
          updatedUser.InvoiceHistory = updatedUser.InvoiceHistory.map((inv) => {
            const currentSubID = inv.UsersSubscriptionID || inv.UserSubscriptionID || inv.ID;
            if (currentSubID === userSubscriptionID || inv.ID === invoice.ID) {
              return {
                ...inv,
                Status: 0,
                IsActive: false,
                EndDate: todayYMD
              };
            }
            return inv;
          });
        }
        updatedUser.hasActiveSubscription = false;
        updatedUser.subscriptionEndingDate = todayYMD;
        onUpdateUser(updatedUser);
      }

      // Close editing mode if currently editing this invoice
      if (selectedInvoiceId === invoice.ID) {
        setIsEditingSubscription(false);
        setEditedSubscription(null);
        setSelectedInvoiceId(null);
      }

      // Automatically show the "Add New Subscription" form as requested
      setIsAddingNewSubscription(true);

      // Trigger parent list refresh to ensure backend sync
      if (onUpdateSuccess) {
        onUpdateSuccess();
      }
    } catch (error) {
      console.error('Error deactivating subscription:', error);
      toast.error(
        error.response?.data?.Message ||
        error.response?.data?.message ||
        error.message ||
        'Failed to deactivate user subscription'
      );
    } finally {
      setDeactivatingId(null);
    }
  };

  // Scenario B: Add New Subscription Handler (When User's Recent Subscription is Inactive)
  const handleSelectNewSubscriptionPlan = (e) => {
    const subId = e.target.value;
    if (!subId) {
      setNewSubscriptionData(prev => ({
        ...prev,
        SubscriptionID: '',
        DurationInMonths: '',
        ExtensionInMonths: 0
      }));
      return;
    }
    const selectedPlan = eligibleSubscriptionPlans.find(s => s.ID === subId);
    setNewSubscriptionData(prev => ({
      ...prev,
      SubscriptionID: subId,
      DurationInMonths: selectedPlan?.DurationInMonths ?? 0,
      ExtensionInMonths: selectedPlan?.ExtensionInMonths ?? 0
    }));
    if (newSubscriptionErrors.SubscriptionID) {
      setNewSubscriptionErrors(prev => ({ ...prev, SubscriptionID: '' }));
    }
  };

  const handleSaveNewSubscription = async () => {
    const validationErrors = {};

    if (!newSubscriptionData.SubscriptionID) {
      validationErrors.SubscriptionID = 'Please select a subscription plan';
    }

    const questionErrors = validateSubscriptionQuestions(newSubscriptionData);

    Object.assign(validationErrors, questionErrors);

    if (Object.keys(validationErrors).length > 0) {
      setNewSubscriptionErrors(validationErrors);
      toast.error('Please complete all required subscription fields.');
      return;
    }

    try {
      setIsSaving(true);

      const payload = {
        UserID: selectedUser.userID || selectedUser.id || editedData.userID,
        SubscriptionID: newSubscriptionData.SubscriptionID,
        DurationInMonths: Number(newSubscriptionData.DurationInMonths) || 0,
        ExtensionInMonths: Number(newSubscriptionData.ExtensionInMonths) || 0,
        SituationProfessionnelle: newSubscriptionData.SituationProfessionnelle,
        HorizonDePlacement: newSubscriptionData.HorizonDePlacement,
        ObjectifDePlacement: newSubscriptionData.ObjectifDePlacement,
        AversionAuRisque: newSubscriptionData.AversionAuRisque
      };

      const result = await updateUserProfile(payload);

      toast.success(result.message || 'New subscription added successfully');

      setIsAddingNewSubscription(false);
      setNewSubscriptionData(INITIAL_NEW_SUBSCRIPTION_STATE);
      setNewSubscriptionErrors({});

      if (onUpdateSuccess) {
        onUpdateSuccess();
      }
    } catch (error) {
      console.error('Error adding new subscription:', error);
      toast.error(
        error.response?.data?.message ||
        error.message ||
        'Failed to add subscription'
      );
    } finally {
      setIsSaving(false);
    }
  };

  const formQuestions = {
    situationProfessionnelle: {
      question: "Situation Professionnelle",
      icon: <Briefcase size={16} />,
    },
    horizon: {
      question: "Quel est votre horizon de placement ?",
      icon: <Clock size={16} />,
      options: [
        "Inférieur à 1 an",
        "Entre 1 an et 5 ans",
        "Supérieur à 5 ans"
      ]
    },
    objectif: {
      question: "Quel est votre objectif de placement ?",
      icon: <Target size={16} />,
      options: [
        "Construire un capital",
        "Générer un revenu complémentaire",
        "Préparer ma retraite",
        "Spéculer à court terme"
      ]
    },
    aversion: {
      question: "Quel est votre aversion au risque ?",
      icon: <Shield size={16} />,
      options: [
        "Conservateur",
        "Modéré",
        "Entrepreneur"
      ]
    }
  };

  const isSaveDisabled = isSaving || Object.values(errors).some(error => error !== '');

  const drawerContent = (
    <>
      <style>{customStyles}</style>

      {/* Backdrop overlay - COMPLETELY BLOCKS all clicks on main content */}
      <div
        className="drawer-backdrop"
        onClick={(e) => {
          // This prevents any click events on the backdrop from doing anything
          e.preventDefault();
          e.stopPropagation();
          return false;
        }}
        onMouseDown={(e) => {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }}
        onMouseUp={(e) => {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }}
      />

      <div className="user-drawer">
        <div className="drawer-header-modern">
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-3" style={{ minWidth: 0, flex: 1, marginRight: '12px' }}>
              <div className="user-avatar-modern">
                {selectedUser.fullName ? selectedUser.fullName.charAt(0).toUpperCase() : 'U'}
              </div>
              <div style={{ minWidth: 0, overflow: 'hidden' }}>
                <div className="d-flex align-items-center gap-2 flex-wrap">
                  <span style={{ color: '#0F172A', fontWeight: '700', fontSize: '18px', letterSpacing: '-0.2px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {selectedUser.fullName || 'User Profile'}
                  </span>
                  <span className={`status-badge ${editedData.isActive ? 'active' : 'inactive'}`}>
                    {editedData.isActive ? 'Active' : 'Suspended'}
                  </span>
                </div>
                <div className="text-secondary-light text-xs mt-1 d-flex align-items-center gap-2 flex-wrap">
                  {selectedUser.os && (
                    <>
                      <span className="badge bg-light text-secondary border">{selectedUser.os}</span>
                    </>
                  )}
                </div>
              </div>
            </div>
            <button
              type="button"
              className="btn-close-circle"
              onClick={onClose}
              title="Close"
              style={{ flexShrink: 0 }}
            >
              <X size={18} />
            </button>
          </div>
        </div>

        <div className="drawer-tabs-container">
          <button
            type="button"
            className={`drawer-tab-btn flex-fill ${activeTab === 'personal' ? 'active' : ''}`}
            onClick={() => setActiveTab('personal')}
          >
            <User size={15} />
            <span>Personal Details</span>
          </button>
          <button
            type="button"
            className={`drawer-tab-btn flex-fill ${activeTab === 'subscription' ? 'active' : ''}`}
            onClick={() => setActiveTab('subscription')}
          >
            <Calendar size={15} />
            <span>Subscription History</span>
          </button>
        </div>

        <div style={{ overflowY: 'auto', overflowX: 'hidden', flex: 1, maxHeight: 'calc(100vh - 120px)', padding: '16px 20px', boxSizing: 'border-box', width: '100%' }}>
          <div>
            <div>
              {activeTab === 'personal' && (
                <div>
                  <div className="mb-4">
                    <div className="w-100">
                      <DetailItem
                        label="First Name"
                        value={editedData.firstName}
                        icon={<User size={16} />}
                        isEditing={editingFields.firstName}
                        onEdit={handleEditToggle}
                        field="firstName"
                        onFieldChange={handleFieldChange}
                      />
                      <DetailItem
                        label="Last Name"
                        value={editedData.lastName}
                        icon={<User size={16} />}
                        isEditing={editingFields.lastName}
                        onEdit={handleEditToggle}
                        field="lastName"
                        onFieldChange={handleFieldChange}
                      />
                      <DetailItem
                        label="Mobile Number"
                        value={editedData.contactNumber}
                        icon={<Phone size={16} />}
                        isEditing={editingFields.contactNumber}
                        onEdit={handleEditToggle}
                        field="contactNumber"
                        onFieldChange={handleFieldChange}
                        onBlur={() => handleFieldBlur('contactNumber', editedData.contactNumber)}
                        error={errors.contactNumber}
                      />
                      <DetailItem
                        label="Email"
                        value={editedData.email}
                        icon={<Mail size={16} />}
                        isEditing={editingFields.email}
                        onEdit={handleEditToggle}
                        field="email"
                        onFieldChange={handleFieldChange}
                        onBlur={() => handleFieldBlur('email', editedData.email)}
                        error={errors.email}
                      />
                      <DetailItem
                        label="Date Of Birth"
                        value={editedData.dob}
                        icon={<Calendar size={16} />}
                        isEditing={editingFields.dob}
                        onEdit={handleEditToggle}
                        field="dob"
                        onFieldChange={handleFieldChange}
                        onBlur={() => handleFieldBlur('dob', editedData.dob)}
                        error={errors.dob}
                      />
                      <div className="personal-fields">
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="d-flex align-items-center">
                            <span className="field-icon-box">
                              <Mail size={16} />
                            </span>
                            <span className="field-label-text">Subscription for email alert</span>
                          </div>
                          <div className="d-flex align-items-center justify-content-end gap-2">
                            <Form.Check
                              type="switch"
                              id="email-alert-switch"
                              checked={editedData.emailAlert}
                              onChange={(e) => {
                                setEditedData(prev => ({ ...prev, emailAlert: e.target.checked }));
                                setHasChanges(true);
                              }}
                              className="mb-0"
                            />
                            <span className="field-value-text">
                              {getYesNo(editedData.emailAlert)}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="personal-fields">
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="d-flex align-items-center">
                            <span className="field-icon-box">
                              <Bell size={16} />
                            </span>
                            <span className="field-label-text">Subscription for Push Notification alert</span>
                          </div>
                          <div className="d-flex align-items-center gap-2">
                            <Form.Check
                              type="switch"
                              id="push-alert-switch"
                              checked={editedData.pushAlert}
                              onChange={(e) => {
                                setEditedData(prev => ({ ...prev, pushAlert: e.target.checked }));
                                setHasChanges(true);
                              }}
                              className="mb-0"
                            />
                            <span className="field-value-text">
                              {getYesNo(editedData.pushAlert)}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="personal-fields">
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="d-flex align-items-center">
                            <span className="field-icon-box">
                              <Calendar size={16} />
                            </span>
                            <span className="field-label-text">Subscription Due Date</span>
                          </div>
                          <span className="field-value-text">
                            {formatDate(selectedUser.subscriptionEndingDate) || 'N/A'}
                          </span>
                        </div>
                      </div>

                      {/* OS Field */}
                      <div className={`personal-fields ${editingFields.os ? 'editing' : ''}`}>
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="d-flex align-items-center">
                            <span className="field-icon-box">
                              <Globe size={16} />
                            </span>
                            <span className="field-label-text">Operating System (OS)</span>
                          </div>
                          <div className="d-flex align-items-center gap-2">
                            {editingFields.os ? (
                              <select
                                className="edit-input"
                                style={{ maxWidth: '160px', padding: '4px 8px' }}
                                value={editedData.os || ''}
                                onChange={(e) => handleFieldChange('os', e.target.value)}
                              >
                                <option value="">Select OS</option>
                                <option value="iOS">iOS</option>
                                <option value="Android">Android</option>
                              </select>
                            ) : (
                              <span className="field-value-text">
                                {editedData.os || 'N/A'}
                              </span>
                            )}
                            <button
                              className={`edit-btn-modern ${editingFields.os ? 'active' : ''}`}
                              onClick={() => handleEditToggle('os')}
                              type="button"
                              title={editingFields.os ? 'Confirm' : 'Edit'}
                            >
                              {editingFields.os ? <Check size={14} /> : <Edit2 size={14} />}
                            </button>
                          </div>
                        </div>
                      </div>

                      {/* Account Status (IsActive / Suspended) */}
                      <div className="personal-fields">
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="d-flex align-items-center">
                            <span className="field-icon-box">
                              <Shield size={16} />
                            </span>
                            <span className="field-label-text">Suspended</span>
                          </div>
                          <div className="d-flex align-items-center gap-2">
                            <Form.Check
                              type="switch"
                              id="account-status-switch"
                              checked={!editedData.isActive}
                              onChange={(e) => {
                                const newIsActive = !e.target.checked;
                                setEditedData(prev => ({ ...prev, isActive: newIsActive, IsActive: newIsActive }));
                                setHasChanges(true);
                              }}
                              className="mb-0"
                            />
                            <span style={{
                              color: !editedData.isActive ? '#C5221F' : '#137333',
                              fontWeight: '600',
                              fontSize: '13px'
                            }}>
                              {!editedData.isActive ? 'Suspended' : 'Active'}
                            </span>
                          </div>
                        </div>
                      </div>

                      <DetailItem
                        label="Password"
                        value={editedData.password || ''}
                        icon={<Shield size={16} />}
                        isEditing={editingFields.password}
                        onEdit={handleEditToggle}
                        field="password"
                        onFieldChange={handleFieldChange}
                        onBlur={() => handleFieldBlur('password', editedData.password)}
                        showPassword={showPassword}
                        onTogglePassword={handleTogglePassword}
                        error={errors.password}
                      />

                      {hasChanges && (
                        <div className="edit-actions d-flex justify-content-end gap-2">
                          <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={handleUndoChanges}
                            disabled={isSaving}
                            className="d-flex align-items-center gap-1"
                            style={{ borderColor: '#D1D5DB', color: '#6B7280' }}
                          >
                            <RefreshCw size={14} />
                            Undo Changes
                          </Button>
                          <Button
                            type="button"
                            size="sm"
                            onClick={handleSaveChanges}
                            disabled={isSaveDisabled}
                            className="btn btn-primary d-flex align-items-center gap-1"
                          >
                            {isSaving ? (
                              <>
                                <Spinner animation="border" size="sm" className="me-1" />
                                Saving...
                              </>
                            ) : (
                              <>
                                <Save size={14} className="me-1" />
                                Save Changes
                              </>
                            )}
                          </Button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {activeTab === 'subscription' && (
                <div>
                  {/* Top Header & Actions for Subscriptions */}
                  {!userHasActiveSubscription && !isAddingNewSubscription && (
                    <div className="d-flex justify-content-end align-items-center mb-3">
                      <Button
                        size="sm"
                        className="btn btn-primary d-flex align-items-center gap-1"
                        onClick={() => {
                          setIsAddingNewSubscription(true);
                          setIsEditingSubscription(false);
                          setSelectedInvoiceId(null);
                        }}
                        style={{ fontSize: '12px' }}
                      >
                        <Plus size={14} />
                        Add New Subscription
                      </Button>
                    </div>
                  )}

                  {/* Scenario B: Add New Subscription Form */}
                  {isAddingNewSubscription && (
                    <div className="subscription-edit-section mb-4">
                      <div className="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
                        <div>
                          <div style={{ color: '#CBA370', fontWeight: '600', fontSize: '15px' }}>
                            Add New Subscription
                          </div>
                        </div>
                        <Button
                          variant="link"
                          className="p-0 text-muted"
                          onClick={() => {
                            setIsAddingNewSubscription(false);
                            setNewSubscriptionData(INITIAL_NEW_SUBSCRIPTION_STATE);
                            setNewSubscriptionErrors({});
                          }}
                        >
                          <X size={18} />
                        </Button>
                      </div>

                      {/* Select Plan */}
                      <div className="mb-3">
                        <label className="subscription-edit-label">
                          Subscription Plan <span className="text-danger">*</span>
                        </label>
                        <select
                          className={`subscription-select ${newSubscriptionErrors.SubscriptionID ? 'border-danger' : ''}`}
                          value={newSubscriptionData.SubscriptionID}
                          onChange={handleSelectNewSubscriptionPlan}
                          disabled={loadingSubscriptions}
                        >
                          <option value="">Select a subscription plan</option>
                          {eligibleSubscriptionPlans.map((plan) => (
                            <option key={plan.ID} value={plan.ID}>
                              {plan.SubscriptionName} - {plan.SubscriptionFee ? `${plan.SubscriptionFee} MAD` : 'Free'}
                            </option>
                          ))}
                        </select>
                        {newSubscriptionErrors.SubscriptionID && (
                          <div className="validation-error">
                            <AlertCircle size={12} />
                            {newSubscriptionErrors.SubscriptionID}
                          </div>
                        )}
                      </div>

                      {/* Duration & Extension */}
                      <div className="row g-2 mb-3">
                        <div className="col-6">
                          <label className="subscription-edit-label">Duration (in Months)</label>
                          <input
                            type="text"
                            className="edit-input"
                            value={newSubscriptionData.DurationInMonths}
                            disabled
                            placeholder="Auto-filled"
                          />
                        </div>
                        <div className="col-6">
                          <label className="subscription-edit-label">Extension (in Months)</label>
                          <input
                            type="number"
                            min="0"
                            className="edit-input"
                            value={newSubscriptionData.ExtensionInMonths}
                            onChange={(e) => setNewSubscriptionData(prev => ({
                              ...prev,
                              ExtensionInMonths: Math.max(0, parseInt(e.target.value, 10) || 0)
                            }))}
                          />
                        </div>
                      </div>

                      {/* Dates Preview */}
                      <div className="row g-2 mb-3 p-2 rounded" style={{ backgroundColor: '#FFFFFF', border: '1px solid #E2E8F0' }}>
                        <div className="col-6">
                          <div style={{ fontSize: '11px', color: '#6B7280' }}>Start Date</div>
                          <div style={{ fontSize: '13px', fontWeight: '600', color: '#111827' }}>
                            {formatDate(newSubscriptionData.StartDate)}
                          </div>
                        </div>
                        <div className="col-6">
                          <div style={{ fontSize: '11px', color: '#6B7280' }}>Calculated End Date</div>
                          <div style={{ fontSize: '13px', fontWeight: '600', color: '#CBA370' }}>
                            {formatDate(newCalculatedEndDate) || 'N/A'}
                          </div>
                        </div>
                      </div>

                      {/* Questions */}
                      <div style={{ marginBottom: '12px' }}>
                        <div className="subscription-edit-label">
                          {formQuestions.situationProfessionnelle.question} <span className="text-danger">*</span>
                        </div>
                        <select
                          className={`subscription-select ${newSubscriptionErrors.SituationProfessionnelle ? 'border-danger' : ''}`}
                          value={newSubscriptionData.SituationProfessionnelle}
                          onChange={(e) => {
                            const val = e.target.value;
                            setNewSubscriptionData(prev => ({ ...prev, SituationProfessionnelle: val }));
                            if (newSubscriptionErrors.SituationProfessionnelle) {
                              setNewSubscriptionErrors(prev => ({ ...prev, SituationProfessionnelle: '' }));
                            }
                          }}
                          disabled={isLoadingSituations}
                        >
                          <option value="">Select Situation</option>
                          {professionalSituations.map((situation) => (
                            <option key={situation.ID} value={situation.Value}>
                              {situation.Value}
                            </option>
                          ))}
                        </select>
                        {newSubscriptionErrors.SituationProfessionnelle && (
                          <div className="validation-error mt-1">
                            <AlertCircle size={12} />
                            {newSubscriptionErrors.SituationProfessionnelle}
                          </div>
                        )}
                      </div>

                      <FormQuestion
                        question={formQuestions.horizon.question}
                        options={formQuestions.horizon.options}
                        selectedValue={newSubscriptionData.HorizonDePlacement}
                        icon={formQuestions.horizon.icon}
                        isEditing={true}
                        required={true}
                        onOptionChange={(_, val) => {
                          setNewSubscriptionData(prev => ({ ...prev, HorizonDePlacement: val }));
                          if (newSubscriptionErrors.HorizonDePlacement) {
                            setNewSubscriptionErrors(prev => ({ ...prev, HorizonDePlacement: '' }));
                          }
                        }}
                        field="HorizonDePlacement"
                        error={newSubscriptionErrors.HorizonDePlacement}
                      />
                      <MultiSelectQuestion
                        question={formQuestions.objectif.question}
                        options={formQuestions.objectif.options}
                        selectedValues={newSubscriptionData.ObjectifDePlacement}
                        icon={formQuestions.objectif.icon}
                        isEditing={true}
                        required={true}
                        onOptionChange={(_, val) => {
                          setNewSubscriptionData(prev => ({ ...prev, ObjectifDePlacement: val }));
                          if (newSubscriptionErrors.ObjectifDePlacement) {
                            setNewSubscriptionErrors(prev => ({ ...prev, ObjectifDePlacement: '' }));
                          }
                        }}
                        field="ObjectifDePlacement"
                        error={newSubscriptionErrors.ObjectifDePlacement}
                      />
                      <FormQuestion
                        question={formQuestions.aversion.question}
                        options={formQuestions.aversion.options}
                        selectedValue={newSubscriptionData.AversionAuRisque}
                        icon={formQuestions.aversion.icon}
                        isEditing={true}
                        required={true}
                        onOptionChange={(_, val) => {
                          setNewSubscriptionData(prev => ({ ...prev, AversionAuRisque: val }));
                          if (newSubscriptionErrors.AversionAuRisque) {
                            setNewSubscriptionErrors(prev => ({ ...prev, AversionAuRisque: '' }));
                          }
                        }}
                        field="AversionAuRisque"
                        error={newSubscriptionErrors.AversionAuRisque}
                      />
                      <div className="subscription-edit-actions">
                        <Button
                          variant="outline-secondary"
                          size="sm"
                          className="d-flex align-items-center"
                          onClick={() => {
                            setIsAddingNewSubscription(false);
                            setNewSubscriptionData(INITIAL_NEW_SUBSCRIPTION_STATE);
                            setNewSubscriptionErrors({});
                          }}
                          disabled={isSaving}
                          style={{ borderColor: '#D1D5DB' }}
                        >
                          <X size={14} className="me-1" />
                          Cancel
                        </Button>
                        <Button
                          type="button"
                          size="sm"
                          className="btn btn-primary d-flex align-items-center"
                          onClick={handleSaveNewSubscription}
                          disabled={isSaving || !newSubscriptionData.SubscriptionID}
                        >
                          {isSaving ? (
                            <>
                              <Spinner animation="border" size="sm" className="me-1" />
                              Adding...
                            </>
                          ) : (
                            <>
                              <Check size={14} className="me-1" />
                              Add Subscription
                            </>
                          )}
                        </Button>
                      </div>
                    </div>
                  )}

                  {/* Existing Invoices List */}
                  <div className="mb-4">
                    {selectedUser.InvoiceHistory && selectedUser.InvoiceHistory.length > 0 ? (
                      selectedUser.InvoiceHistory.map((invoice, index) => {
                        const isSubscriptionActive = isInvoiceActive(invoice);

                        return (
                          <div key={invoice.ID || index} className="mb-3">
                            {invoice.StartDate && invoice.EndDate && (
                              <Accordion className="compact-accordion">
                                <Accordion.Item eventKey="0">
                                  <Accordion.Header>
                                    <div className="d-flex justify-content-between align-items-center w-100 pe-2">
                                      {/* Left Side: Icon & Title */}
                                      <div className="d-flex align-items-center gap-2 h-100">
                                        <Calendar size={14} className="text-muted" style={{ transform: 'translateY(-1px)' }} />
                                        <span className="accordion-title-text">
                                          {invoice.SubscriptionTitle || 'Subscription Plan'}
                                        </span>
                                      </div>

                                      {/* Right Side: Timeline Dates, Status, Actions */}
                                      <div className="d-flex align-items-center gap-3 h-100">
                                        {/* Compact Date Range */}
                                        <div className="d-none d-sm-block text-muted header-date-range">
                                          {formatDate(invoice.StartDate)} - {formatDate(invoice.EndDate)}
                                        </div>

                                        {/* Dynamic Status Badge */}
                                        <span className={`status-badge ${isSubscriptionActive ? 'active' : 'inactive'}`}>
                                          {isSubscriptionActive ? 'Active' : 'Inactive'}
                                        </span>

                                        {/* Actions Container */}
                                        <div className="d-flex align-items-center gap-3 visual-actions-group">
                                          {!isEditingSubscription && (
                                            isSubscriptionActive ? (
                                              <div className="d-flex align-items-center gap-2">
                                                <Button
                                                  variant="link"
                                                  size="sm"
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleEditSubscription(invoice);
                                                  }}
                                                  className="accordion-edit-btn"
                                                  title="Edit Subscription Questions & End Date"
                                                >
                                                  <Edit2 size={13} />
                                                  <span>Edit</span>
                                                </Button>
                                                {/* <Button
                                                  variant="link"
                                                  size="sm"
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleDeactivateSubscription(invoice);
                                                  }}
                                                  disabled={deactivatingId === invoice.ID}
                                                  className="accordion-deactivate-btn"
                                                  title="Deactivate this active subscription"
                                                >
                                                  {deactivatingId === invoice.ID ? (
                                                    <Spinner animation="border" size="sm" style={{ width: 12, height: 12 }} />
                                                  ) : (
                                                    <XCircle size={13} />
                                                  )}
                                                  <span>Deactivate</span>
                                                </Button> */}
                                              </div>
                                            ) : (
                                              <span
                                                className="text-muted"
                                                style={{ fontSize: '11px', cursor: 'not-allowed', opacity: 0.7 }}
                                                title="Inactive subscriptions cannot be edited"
                                              >
                                                Locked
                                              </span>
                                            )
                                          )}
                                          <div className="custom-arrow-parent">
                                            <div className='custom-arrow'>
                                              ^
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </Accordion.Header>
                                  <Accordion.Body>
                                    {/* Detailed View inside Body */}
                                    <div className="d-flex justify-content-between mb-3 pb-3 border-bottom-dashed">
                                      <div>
                                        <div style={{ fontSize: '12px', color: '#6B7280' }}>Start Date</div>
                                        <div style={{ fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                                          {formatDate(invoice.StartDate)}
                                        </div>
                                      </div>
                                      <div>
                                        <div style={{ fontSize: '12px', color: '#6B7280' }}>End Date</div>
                                        <div style={{ fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                                          {formatDate(invoice.EndDate)}
                                        </div>
                                      </div>
                                    </div>

                                    {/* Scenario A: Edit Active Subscription form inside body */}
                                    {isEditingSubscription && selectedInvoiceId === invoice.ID ? (
                                      <div className="subscription-edit-section">
                                        {/* Subscription End Date Picker */}
                                        <div style={{ marginBottom: '14px' }}>
                                          <label className="subscription-edit-label d-flex align-items-center gap-1">
                                            <Calendar size={14} style={{ color: '#CBA370' }} />
                                            <span>Subscription End Date <span className="text-danger">*</span></span>
                                          </label>
                                          <input
                                            type="date"
                                            className={`edit-input ${subscriptionErrors.EndDate ? 'border-danger' : ''}`}
                                            min={getTodayFormatted()}
                                            value={editedSubscription?.EndDate || ''}
                                            onChange={(e) => {
                                              const newEnd = e.target.value;
                                              setEditedSubscription(prev => ({ ...prev, EndDate: newEnd }));
                                              if (subscriptionErrors.EndDate) {
                                                setSubscriptionErrors(prev => ({ ...prev, EndDate: '' }));
                                              }
                                            }}
                                            style={{ maxWidth: '220px' }}
                                          />
                                          {subscriptionErrors.EndDate && (
                                            <div className="validation-error">
                                              <AlertCircle size={12} />
                                              {subscriptionErrors.EndDate}
                                            </div>
                                          )}
                                          <small className="text-muted d-block mt-1" style={{ fontSize: '11px' }}>
                                            End Date can be today or any future date.
                                          </small>
                                        </div>

                                        <div style={{ marginBottom: '12px' }}>
                                          <div className="subscription-edit-label">
                                            {formQuestions.situationProfessionnelle.question} <span className="text-danger">*</span>
                                          </div>
                                          <select
                                            className={`subscription-select ${subscriptionErrors.SituationProfessionnelle ? 'border-danger' : ''}`}
                                            value={editedSubscription?.SubscriptionDetail?.SituationProfessionnelle || ''}
                                            onChange={(e) => handleSubscriptionFieldChange('SituationProfessionnelle', e.target.value)}
                                            disabled={isLoadingSituations}
                                          >
                                            <option value="">Select Situation</option>
                                            {professionalSituations.map((situation) => (
                                              <option key={situation.ID} value={situation.Value}>
                                                {situation.Value}
                                              </option>
                                            ))}
                                          </select>
                                          {subscriptionErrors.SituationProfessionnelle && (
                                            <div className="validation-error mt-1">
                                              <AlertCircle size={12} />
                                              {subscriptionErrors.SituationProfessionnelle}
                                            </div>
                                          )}
                                        </div>

                                        <FormQuestion
                                          question={formQuestions.horizon.question}
                                          options={formQuestions.horizon.options}
                                          selectedValue={editedSubscription?.SubscriptionDetail?.HorizonDePlacement || ''}
                                          icon={formQuestions.horizon.icon}
                                          isEditing={true}
                                          required={true}
                                          onOptionChange={handleSubscriptionFieldChange}
                                          field="HorizonDePlacement"
                                          error={subscriptionErrors.HorizonDePlacement}
                                        />

                                        <MultiSelectQuestion
                                          question={formQuestions.objectif.question}
                                          options={formQuestions.objectif.options}
                                          selectedValues={editedSubscription?.SubscriptionDetail?.ObjectifDePlacement || []}
                                          icon={formQuestions.objectif.icon}
                                          isEditing={true}
                                          required={true}
                                          onOptionChange={handleSubscriptionFieldChange}
                                          field="ObjectifDePlacement"
                                          error={subscriptionErrors.ObjectifDePlacement}
                                        />

                                        <FormQuestion
                                          question={formQuestions.aversion.question}
                                          options={formQuestions.aversion.options}
                                          selectedValue={editedSubscription?.SubscriptionDetail?.AversionAuRisque || ''}
                                          icon={formQuestions.aversion.icon}
                                          isEditing={true}
                                          required={true}
                                          onOptionChange={handleSubscriptionFieldChange}
                                          field="AversionAuRisque"
                                          error={subscriptionErrors.AversionAuRisque}
                                        />

                                        <div className="subscription-edit-actions d-flex justify-content-between align-items-center">
                                          <Button
                                            type="button"
                                            variant="outline-danger"
                                            size="sm"
                                            className="d-flex align-items-center gap-1"
                                            onClick={() => handleDeactivateSubscription(invoice)}
                                            disabled={isSaving || deactivatingId === invoice.ID}
                                          >
                                            {deactivatingId === invoice.ID ? (
                                              <Spinner animation="border" size="sm" className="me-1" />
                                            ) : (
                                              <XCircle size={14} className="me-1" />
                                            )}
                                            Deactivate Subscription
                                          </Button>
                                          <div className="d-flex align-items-center gap-2">
                                          <Button
                                            variant="outline-secondary"
                                            size="sm"
                                            className='d-flex justify-content-center align-items-center'
                                            onClick={handleCancelSubscriptionEdit}
                                            disabled={isSaving}
                                            style={{ borderColor: '#D1D5DB' }}
                                          >
                                            <X size={14} className="me-1" />
                                            Cancel
                                          </Button>
                                          <Button
                                            type="button"
                                            size="sm"
                                            className='btn btn-primary d-flex justify-content-center align-items-center'
                                            onClick={handleSaveSubscriptionChanges}
                                            disabled={isSaving}
                                          >
                                            {isSaving ? (
                                              <>
                                                <Spinner animation="border" size="sm" className="me-1" />
                                                Saving...
                                              </>
                                            ) : (
                                              <>
                                                <Save size={14} className="me-1" />
                                                Save
                                              </>
                                            )}
                                          </Button>
                                          </div>
                                        </div>
                                      </div>
                                    ) : (
                                      invoice.SubscriptionDetail && (
                                        <div className="subscription-box" style={{ padding: '0px', marginTop: '12px' }}>
                                          <SingleValueQuestion
                                            question={formQuestions.situationProfessionnelle.question}
                                            value={invoice.SubscriptionDetail.SituationProfessionnelle}
                                            icon={formQuestions.situationProfessionnelle.icon}
                                          />
                                          <FormQuestion
                                            question={formQuestions.horizon.question}
                                            options={formQuestions.horizon.options}
                                            selectedValue={invoice.SubscriptionDetail.HorizonDePlacement}
                                            icon={formQuestions.horizon.icon}
                                          />
                                          <MultiSelectQuestion
                                            question={formQuestions.objectif.question}
                                            options={formQuestions.objectif.options}
                                            selectedValues={invoice.SubscriptionDetail.ObjectifDePlacement || []}
                                            icon={formQuestions.objectif.icon}
                                          />
                                          <FormQuestion
                                            question={formQuestions.aversion.question}
                                            options={formQuestions.aversion.options}
                                            selectedValue={invoice.SubscriptionDetail.AversionAuRisque}
                                            icon={formQuestions.aversion.icon}
                                          />
                                        </div>
                                      )
                                    )}
                                  </Accordion.Body>
                                </Accordion.Item>
                              </Accordion>
                            )}
                          </div>
                        );
                      })
                    ) : (
                      <div className="empty-state">
                        <Icon icon="mdi:file-document-outline" width={48} height={48} style={{ color: '#CBD5E1', marginBottom: '16px' }} />
                        <div style={{ color: '#6B7280', fontSize: '14px', marginBottom: '12px' }}>
                          No subscription history found
                        </div>
                        {/* {!isAddingNewSubscription && (
                          <Button
                            size="sm"
                            className="btn btn-primary d-flex align-items-center gap-1 mx-auto"
                            onClick={() => {
                              setIsAddingNewSubscription(true);
                              setIsEditingSubscription(false);
                              setSelectedInvoiceId(null);
                            }}
                            style={{ fontSize: '12px' }}
                          >
                            <Plus size={14} />
                            Add New Subscription
                          </Button>
                        )} */}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );

  return ReactDOM.createPortal(drawerContent, document.body);
};

export default FilterUserDrawer;